import { Megaphone } from "lucide-react";

/**
 * Selo "de onde veio o pedido" (Vendas → Pedidos): Meta, link de divulgação,
 * SMS ou ligação. Lê `pedido.origem_campanha`, que o servidor preenche
 * ({canal, rotulo, nome, campaign_id, adset_id, ad_id}). Sem origem, não
 * renderiza nada.
 */

// Opções do filtro Origem — os mesmos valores que o servidor aceita em
// `GET /pedidos/stats?origem_campanha=` (meta, link, sms, voz, nenhuma).
export const OPCOES_ORIGEM = [
  { value: "meta", label: "Anúncio Meta" },
  { value: "link", label: "Link de divulgação" },
  { value: "sms", label: "Disparo SMS" },
  { value: "voz", label: "Ligação" },
  { value: "nenhuma", label: "Sem campanha" },
];

const COR = {
  meta: "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300",
  link: "bg-primary/10 text-primary",
  sms: "bg-primary/10 text-primary",
  voz: "bg-primary/10 text-primary",
};

export default function SeloOrigem({ origem, compacto = false }) {
  if (!origem || !origem.canal) return null;
  const rotulo = origem.rotulo || origem.canal;
  const detalhe = origem.ad_id ? ` · anúncio ${origem.ad_id}` : "";
  return (
    <span
      className={`text-[10px] rounded-full px-1.5 py-0.5 font-medium truncate inline-flex items-center gap-0.5 ${compacto ? "max-w-[140px]" : "max-w-[200px]"} ${COR[origem.canal] || COR.link}`}
      title={`Veio de ${rotulo.toLowerCase() === "meta" ? "anúncio da Meta" : rotulo}: ${origem.nome || ""}${detalhe}`}
      data-e2e="selo-origem"
    >
      {origem.canal === "meta" && <Megaphone className="w-2.5 h-2.5 shrink-0" />}
      {rotulo}: {origem.nome}
    </span>
  );
}
